import { type ReactNode } from 'react'
import type { ElementType, ComponentPropsWithoutRef } from 'react'
import { twMerge } from 'tailwind-merge'

export type TRowProps<T extends ElementType = 'div'> = {
  children: ReactNode
  className?: string
  onClick?: () => void
  as?: T
} & Omit<
  ComponentPropsWithoutRef<T>,
  'as' | 'children' | 'className' | 'onClick'
>

export const Row = <T extends ElementType = 'div'>(props: TRowProps<T>) => {
  const { children, className, onClick, as: Component = 'div', ...rest } = props
  return (
    <Component
      className={twMerge('flex items-center w-full', className)}
      {...rest}
    >
      {onClick ? (
        <button
          onClick={onClick}
          className={twMerge('w-full h-full flex items-center', className)}
        >
          {children}
        </button>
      ) : (
        children
      )}
    </Component>
  )
}
